// extracted by mini-css-extract-plugin
export var cell = "pagination-module--cell--709dd";
export var ellipsis = "pagination-module--ellipsis--7c566";
export var genericContainer = "pagination-module--genericContainer--845e1";
export var icon = "pagination-module--icon--2de09";
export var left = "pagination-module--left--fc535";
export var paginationContainer = "pagination-module--paginationContainer--202f8";
export var selected = "pagination-module--selected--1a0ce";